"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = new /** @class */ (function () {
    function EventsHelper() {
        this.isTouchEnabled = (('ontouchstart' in window));
        this.clickOrTouchEvent = this.isTouchEnabled ? 'touchend' : 'click';
        this.keyDown = 'keydown';
        this.dragging = false;
    }
    EventsHelper.prototype.live = function (selector, eventType, fn, rootElement) {
        var _this = this;
        if (rootElement === void 0) { rootElement = document; }
        var that = this;
        // Check if user has moved
        rootElement.removeEventListener('touchmove', function (event) {
            that.dragging = true;
        });
        rootElement.addEventListener('touchmove', function (event) {
            that.dragging = true;
        });
        rootElement.removeEventListener(eventType, function (event) {
            _this.createEventListener(event, rootElement, selector, fn);
        });
        rootElement.addEventListener(eventType, function (event) {
            _this.createEventListener(event, rootElement, selector, fn);
        });
    };
    EventsHelper.prototype.createEventListener = function (event, rootElement, selector, fn) {
        var _this = this;
        var _a, _b;
        var elements = rootElement.querySelectorAll(selector);
        // First try get clicked element from event path
        var target = event.path && Array.isArray(event.path) ? event.path[0] : null;
        var clickedElement = target ? (target.matches(selector) ? target : target.closest(selector)) : null;
        // Then try get clicked element from event target
        if (clickedElement == null) {
            clickedElement = event.target.matches(selector) ? event.target : event.target.closest(selector);
        }
        // If element still is null try get it from clicked point
        if (!clickedElement && this.isTouchEnabled) {
            var x = parseInt((_a = event.clientX) !== null && _a !== void 0 ? _a : (event.changedTouches && event.changedTouches[0] ? event.changedTouches[0].clientX : null));
            var y = parseInt((_b = event.clientY) !== null && _b !== void 0 ? _b : (event.changedTouches && event.changedTouches[0] ? event.changedTouches[0].clientY : null));
            if (x && y && rootElement.elementFromPoint) {
                clickedElement = rootElement.elementFromPoint(x, y);
                if (clickedElement) {
                    clickedElement = clickedElement.matches(selector) ? clickedElement : clickedElement.closest(selector);
                }
            }
        }
        for (var i = 0; i < elements.length; i++) {
            if (clickedElement && clickedElement === elements[i]) {
                if (this.isTouchEnabled && !this.dragging) {
                    fn(event, clickedElement);
                }
                else if (!this.isTouchEnabled) {
                    fn(event, clickedElement);
                }
                break;
            }
        }
        setTimeout(function () {
            _this.dragging = false;
        }, 100);
    };
    return EventsHelper;
}());
